import { useQuery } from "@tanstack/react-query";

import { clientChangeHistoryApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { ChangeHistoryScope } from "./useChangeHistoryScope";

export function useClientChangeHistory(clientId: string, scope: ChangeHistoryScope) {
  return useQuery({
    queryKey: [QueryKey.ClientChangeHistory, clientId, scope.section, scope.entryId],
    queryFn: () =>
      clientChangeHistoryApi.getClientChangeHistory({
        clientId,
        section: scope.section,
        entryId: scope.entryId,
      }),
    // Same reasoning as useClientChangeInfo: re-opening the dialog must not re-run the section
    // diff. useInvalidateChangeHistoryOnSave invalidates this client's key after a save succeeds.
    staleTime: Infinity,
  });
}
